import React from 'react';
import { useTranslation } from 'react-i18next';

import { makeRequest } from '@/js/libs/api';
import { UpdateBanner } from '@/js/libs/ui/src/V2';

const CHECK_FREQUENCY = 60 * 1000;

const ReloadHeader: React.FC = () => {
  const [t] = useTranslation(['backend', 'common', 'components']);
  const refTimer = React.useRef<NodeJS.Timeout | null>(null);
  const [tick, setTick] = React.useState<number>(0);
  const [hasUpdates, setUpdates] = React.useState<boolean>(false);

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-restricted-syntax
  const checkUpdates = React.useCallback(async () => {
    const response = await makeRequest<{ data: string; responseCode: 200; headers: null }>({
      method: 'GET',
      baseURL: '',
      url: '/COMMITHASH.txt',
      responseTypes: 'text',
      requestType: 'json',
    });
    if (response.data.data.trim() !== window.audienzzGlobals.COMMITHASH) {
      setUpdates(true);
    } else {
      refTimer.current = setTimeout(() => {
        setTick((v) => v + 1);
        refTimer.current = null;
      }, CHECK_FREQUENCY);
    }
  }, [refTimer]);

  React.useEffect(() => {
    checkUpdates();
    return () => {
      if (refTimer.current) {
        clearTimeout(refTimer.current);
      }
    };
  }, [checkUpdates, tick]);
  if (!hasUpdates) {
    return null;
  }
  return (
    <UpdateBanner
      title={t('components:RELOAD_TITLE')}
      text={t('components:RELOAD_TEXT')}
      onReload={() => window.location.reload()}
      dataTestId='system-updates-available-reload-button'
    />
  );
};

export default ReloadHeader;
